/** @prettier */

/**
 * ゲートウェイ追加
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';

//MTH component import
import NoMoreRegister from '../../component/NoMoreRegister';
import {ChkInputTextbox} from '../../component/ChkInputTextbox';
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {
  getCompositionsActivation,
  postCompositionsActivation,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {sortByUnicode} from '../../functions/sort';
import {format, limit} from '../../define';
import {useTranslation} from 'react-i18next';
import {
  AddButton,
  PrimaryButton,
  SecondaryButton,
} from '../../component/BasicButton';

const GWAddDialog = (props: {
  activateButtonName: string;
  tempActivateGW: apiIF.res.getCompositionsActivation | null;
  setTempActivateGW: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsActivation | null>
  >;
  setRestActivationTime: React.Dispatch<React.SetStateAction<string[]>>;
  gwInfo: apiIF.res.getCompositionsGateway | null;
}) => {
  //パスパラメータ取得
  const {siteID} = useParams();

  const [gwName, setGWName] = useState(''); //ゲートウェイの名前
  const [activationCode, setActivationCode] = useState(''); //アクティベーションコード(代理店)
  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false); //ダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //API使用時エラー発生ダイアログ表示フラグ
  const [okBtnDisabled, setOKBtnDisabled] = useState(true); //OKボタン非表示フラグ

  //TextBoxのエラー状態
  const [gwNameError, setGWNameError] = useState(false); //ゲートウェイの名前
  const [activationCodeError, setActivationCodeError] = useState(false); //アクティベーションコード(代理店)

  //入力項目のチェック
  useEffect(() => {
    if (
      gwName === '' ||
      gwNameError ||
      activationCode === '' ||
      activationCodeError ||
      apiWait
    ) {
      setOKBtnDisabled(true);
    } else {
      setOKBtnDisabled(false);
    }
  }, [gwName, gwNameError, activationCode, activationCodeError, apiWait]);

  /**
   * ADD GATEWAYボタン押下時処理
   */
  const handleClickOpen = () => {
    setIsOpenAddDialog(true);
  };
  /**
   * OKボタン押下時処理
   */
  const activateGateway = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined) return;

    setAPIWait(true);

    //ゲートウェイ追加
    postCompositionsActivation(siteID, {
      'gateway-name': gwName,
      'agency-code': activationCode,
    })
      .then(() => {
        //仮登録されたゲートウェイの情報を取得
        return getCompositionsActivation(siteID, {'max-result': 100});
      })
      .then(response => {
        //表示内容をUnicode順に並び替え
        response['gateway-informations'].sort(sortByUnicode('gateway-name'));

        props.setRestActivationTime(
          response['gateway-informations'].map(info => info['time-remaining'])
        );
        props.setTempActivateGW(response);
        setIsOpenAddDialog(false);
        setGWName('');
        setActivationCode('');
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    setGWName('');
    setActivationCode('');
    setIsOpenAddDialog(false);
  };

  const trans = useTranslation().t; //翻訳関数

  return (
    <>
      {/* ゲートウェイ追加ボタンの表示 */}
      <AddButton
        onClick={handleClickOpen}
        id={'mv-btnAddGw'}
        buttonText={props.activateButtonName}
      />
      {props.gwInfo &&
      props.tempActivateGW &&
      props.gwInfo['gateway-informations'].length +
        props.tempActivateGW['gateway-informations'].length >=
        limit.REGISTRATION_NUM_GW_MAX ? (
        <NoMoreRegister
          open={isOpenAddDialog}
          setOpen={setIsOpenAddDialog}
          title={trans('NoMoreRegist.errorDlg.title')}
          text={trans('NoMoreRegist.errorDlg.msg')}
        />
      ) : (
        <Dialog
          open={isOpenAddDialog}
          onClose={handleClose}
          aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">
            {trans('GWAddDialog.dialogBox.title')}
          </DialogTitle>
          <DialogContent>
            {/* ダイアログに表示するメッセージ */}
            <DialogContentText>
              {trans('GWAddDialog.dialogBox.msg')}
            </DialogContentText>
            <div>
              {/* ゲートウェイの名前 */}
              <ChkInputTextbox
                setValue={setGWName}
                setError={setGWNameError}
                chkLength={format.GW_NAME_LENGTH_MAX}
                type="text"
                label={trans(
                  'GWAddDialog.dialogBox.txtField.label.gatewayName'
                )}
                value={gwName}
                id="mv-inputAddGwName"
                class="gwSetting__contents__textBox--gwName"
                helperText=" "
                errHelperText={trans(
                  'GWAddDialog.dialogBox.txtField.errHelperTxt'
                )}
                variant="standard"
                autoFocus={true}
                margin="dense"
                chkInputProhibitedCharacter={format.BASIC_PATTERN_S3_POLICY}
              />
              {/* アクティべーションコード */}
              <ChkInputTextbox
                setValue={setActivationCode}
                setError={setActivationCodeError}
                chkLength={format.ACTIVATION_CODE_LENGTH_MAX}
                type="text"
                label={trans(
                  'GWAddDialog.dialogBox.txtField.label.activationCode'
                )}
                value={activationCode}
                id="mv-inputAddactivationCode"
                class="gwSetting__contents__textBox--gwName"
                helperText=" "
                errHelperText={trans(
                  'GWAddDialog.dialogBox.txtField.errHelperTxt'
                )}
                variant="standard"
                margin="dense"
                onKeyDown={event => {
                  if (event.key === 'Enter' && okBtnDisabled === false) {
                    event.preventDefault();
                    activateGateway();
                  }
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <SecondaryButton
              disabled={apiWait}
              onClick={handleClose}
              buttonText={trans('DeleteAccountDialog.buttonTxt.cancel')}
              id={'mv-btnCancelAddGw'}
            />
            <PrimaryButton
              onClick={activateGateway}
              buttonText={trans('GWAddDialog.dialogBox.buttonTxt.ok')}
              id="mv-btnOkAddGw"
              disabled={okBtnDisabled}
              apiWait={apiWait}
            />
          </DialogActions>
        </Dialog>
      )}
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id="mv-btnErrAddGw"
      />
    </>
  );
};
export default GWAddDialog;
